module.exports = __webpack_public_path__ + "img/european-union.c2488419.svg";